import { Box } from "@chakra-ui/layout";
import { Row, Col } from "antd";
import { PessoaDto } from "core/features/unidades/typings/unidade";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { Control, UseFormWatch } from "react-hook-form";
import Field from "components/Input/Field";
import SelectPessoas from "components/Input/SelectPessoas";

import SelectBooleano from "components/Input/SelectBooleano";

interface FormSelectMoradorProps {
  control: Control<PessoaDto, object>;
  watch: UseFormWatch<PessoaDto>;
}

function FormSelectMorador({ control, watch }: FormSelectMoradorProps) {
  const moradorExistente = watch("moradorExistente");

  return (
    <>
      <Box as={Row} mb={6} gutter={16}>
        <Col sm={10}>
          <Field
            control={control}
            label="É morador ou funcionário do condomínio?"
            name="moradorExistente"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectBooleano {...field} isInvalid={isInvalid} />
            )}
          />
        </Col>

        {moradorExistente === "s" ? (
          <Col sm={14}>
            <Field
              shouldUnregister
              label="Selecionar a pessoa"
              control={control}
              name="pessoaId"
              rules={{ required: "Campo obrigatório" }}
              render={({ field, isInvalid }) => (
                <SelectPessoas
                  {...field}
                  isInvalid={isInvalid}
                  incluirPessoasComUnidade
                  tipoEntidades={[
                    TipoEntidadeEnum.Condomino,
                    TipoEntidadeEnum.Funcionario,
                  ]}
                />
              )}
            />
          </Col>
        ) : null}
      </Box>
    </>
  );
}

export default FormSelectMorador;
